import {imgs_init} from '@/base/base';
import {create_title} from '@/base/titleData';
import img_effects from '@/base/img_effects'
export default {
  img_effects,
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_widgets_infor: {
    //图片宽度
    img_size:{
      radio_val:'default',
      default:{
        width:'100%',
        height:'33.33%',
      },
      custom:{
        width:'100%',
        height:'40%',
      }
    },

    //图片缩放
    backgroundSize:{
      radio_val:'default',
      default:{
        backgroundSize:'cover'
      },
      custom:{
        backgroundSize:'auto'
      }
    },
    banner_set:{
      radio_val:'default',
      default:{
        speed:0.5,//切换速度
        delay:2,//展示时间
      },
      custom:{
        speed:3,//切换速度
        delay:5,//展示时间
      }
    },

    //图片描述
    alt_display:'true',

    title:create_title('Carousel Multi-image')


  },
  mb_widgets_infor: {
    title:create_title('Carousel Multi-image'),
  //图片描述
    alt_display:'true',

  },
  listArr: {
    title: 'Carousel Multi-image',
    type:'custom',
    module_style:'0',
    //直接添加的
    custom:[...imgs_init()],

    //选择图册
    systom:[]
  },
}



// WEBPACK FOOTER //
// ./src/widgets/basic_banner/style.js